var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm.send_store
            ? _c("div", { staticClass: "card-body" }, [
                _c(
                  "form",
                  {
                    attrs: { action: "" },
                    on: { submit: _vm.requestCalculation },
                  },
                  [
                    _c("div", { staticClass: "flex" }, [
                      _c("div", [
                        _c("label", [_vm._v("Склад отправитель")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.send_store,
                                expression: "send_store",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "send_store" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.send_store = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.send_store_list, function (store, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: store.id } },
                              [
                                _vm._v(
                                  _vm._s(store.name) +
                                    "\n                                    "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", [_vm._v("Склад получатель")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.receive_store,
                                expression: "receive_store",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "receive_store" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.receive_store = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(
                            _vm.receive_store_list,
                            function (store, index) {
                              return _c(
                                "option",
                                { key: index, domProps: { value: store.id } },
                                [
                                  _vm._v(
                                    _vm._s(store.name) +
                                      "\n                                    "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "relative",
                            "min-width": "200px",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              staticStyle: {
                                position: "absolute",
                                bottom: "0",
                              },
                              attrs: { type: "submit" },
                            },
                            [
                              _vm._v(
                                "\n                                    Создать автосписок\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "check_1" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.default_formula,
                                  expression: "default_formula",
                                },
                              ],
                              staticClass: "from-control",
                              attrs: {
                                type: "checkbox",
                                name: "",
                                id: "check_1",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.default_formula)
                                  ? _vm._i(_vm.default_formula, null) > -1
                                  : _vm.default_formula,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.default_formula,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.default_formula = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.default_formula = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.default_formula = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              "\n                                    Использовать 60/17\n                                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("pulse-loader", {
          staticStyle: { "text-align": "center" },
          attrs: { loading: _vm.loading, color: _vm.color },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.request
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("H5", [
                    _vm._v("Перемещение "),
                    _c("strong", [_vm._v(_vm._s(_vm.send_store_name))]),
                    _vm._v(" в "),
                    _c("strong", [_vm._v(_vm._s(_vm.receive_store_name))]),
                    _vm._v("\n                        на сумму: "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.calculated_total_sum_value)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex blocks-2" }, [
                    _c("div", [
                      _c("div", [
                        _c("label", { attrs: { for: "check_2" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.noCloseVisible,
                                expression: "noCloseVisible",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "",
                              id: "check_2",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.noCloseVisible)
                                ? _vm._i(_vm.noCloseVisible, null) > -1
                                : _vm.noCloseVisible,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.noCloseVisible,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.noCloseVisible = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.noCloseVisible = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.noCloseVisible = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n                                    Показать препараты, которые не закрываются\n                                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { attrs: { for: "check_3" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.storeDetailsVisible,
                                expression: "storeDetailsVisible",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "",
                              id: "check_3",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.storeDetailsVisible)
                                ? _vm._i(_vm.storeDetailsVisible, null) > -1
                                : _vm.storeDetailsVisible,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.storeDetailsVisible,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.storeDetailsVisible = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.storeDetailsVisible = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.storeDetailsVisible = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n                                    Показать детали\n                                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { attrs: { for: "check_4" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showReserve,
                                expression: "showReserve",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "",
                              id: "check_4",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.showReserve)
                                ? _vm._i(_vm.showReserve, null) > -1
                                : _vm.showReserve,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showReserve,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showReserve = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showReserve = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showReserve = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n                                    Показать брони\n                                "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { attrs: { for: "check_5" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.hideNoReserve,
                                expression: "hideNoReserve",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "",
                              id: "check_5",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.hideNoReserve)
                                ? _vm._i(_vm.hideNoReserve, null) > -1
                                : _vm.hideNoReserve,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.hideNoReserve,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.hideNoReserve = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.hideNoReserve = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.hideNoReserve = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n                                    Отправлять только бронь\n                                "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          on: { click: _vm.printTable },
                        },
                        [_vm._v("Печать")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "printTable" } }, [
                    _c(
                      "table",
                      { staticClass: "table table-hover table-bordered" },
                      [
                        _c("thead", [
                          _c("th", { staticClass: "wd-40" }),
                          _vm._v(" "),
                          _c("th", { staticClass: "wd-40" }),
                          _vm._v(" "),
                          _c("th", [_vm._v("Препарат")]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hideNoReserve,
                                  expression: "hideNoReserve",
                                },
                              ],
                              staticClass: "wd-200",
                            },
                            [_vm._v("Только бронь")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.hideNoReserve,
                                  expression: "!hideNoReserve",
                                },
                              ],
                              staticClass: "wd-200",
                            },
                            [_vm._v("Всего")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showReserve,
                                  expression: "showReserve",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [_vm._v("Срочная бронь")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showReserve,
                                  expression: "showReserve",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [_vm._v("Обычная бронь")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showReserve,
                                  expression: "showReserve",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [_vm._v("Запас")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.storeDetailsVisible,
                                  expression: "storeDetailsVisible",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [_vm._v("Не закрываем бронь")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.storeDetailsVisible,
                                  expression: "storeDetailsVisible",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [_vm._v("Не закрываем запас")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.storeDetailsVisible,
                                  expression: "storeDetailsVisible",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [
                              _vm._v(
                                "Не закр. запрос запаса на отправителе\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.hideNoReserve,
                                  expression: "!hideNoReserve",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [_vm._v("Сумма")]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hideNoReserve,
                                  expression: "hideNoReserve",
                                },
                              ],
                              staticClass: "wd-100",
                            },
                            [_vm._v("Сумма брони")]
                          ),
                          _vm._v(" "),
                          _c("th", { staticClass: "wd-200" }, [
                            _vm._v("Морион"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.orderedPrepNames(_vm.request.prep_names),
                            function (prep, index) {
                              return _c("tr", { key: index }, [
                                _c("td", { staticClass: "row_num" }, [
                                  _vm._v(_vm._s(1 + index)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  prep.cool
                                    ? _c("span", {
                                        staticClass: "icon icon-snowflake",
                                      })
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(prep.name) +
                                      "\n                                    "
                                  ),
                                  _vm.request.pack_details[prep.id]
                                    ? _c(
                                        "span",
                                        { staticClass: "pack_details" },
                                        [
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.request.pack_details[prep.id]
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.request.store_details[prep.id]
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "store_details text-muted",
                                        },
                                        [
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.request.store_details[prep.id]
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.hideNoReserve,
                                        expression: "hideNoReserve",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.request.reserve_for_close[prep.id]
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.hideNoReserve,
                                        expression: "!hideNoReserve",
                                      },
                                    ],
                                  },
                                  [_vm._v(_vm._s(_vm.printAll(prep.id)))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showReserve,
                                        expression: "showReserve",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.request.reserve_requests.urgent[
                                          prep.id
                                        ]
                                          ? _vm.request.reserve_requests.urgent[
                                              prep.id
                                            ]
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showReserve,
                                        expression: "showReserve",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.request.reserve_requests.regular[
                                          prep.id
                                        ]
                                          ? _vm.request.reserve_requests
                                              .regular[prep.id]
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showReserve,
                                        expression: "showReserve",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.request.store_requests[prep.id]
                                          ? _vm.request.store_requests[prep.id]
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.storeDetailsVisible,
                                        expression: "storeDetailsVisible",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.printNoCloseFigures(
                                          prep.id,
                                          "reserve"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.storeDetailsVisible,
                                        expression: "storeDetailsVisible",
                                      },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.printNoCloseFigures(
                                          prep.id,
                                          "storage"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.storeDetailsVisible,
                                      expression: "storeDetailsVisible",
                                    },
                                  ],
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.hideNoReserve,
                                      expression: "!hideNoReserve",
                                    },
                                  ],
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hideNoReserve,
                                      expression: "hideNoReserve",
                                    },
                                  ],
                                }),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(prep.id))]),
                              ])
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.invoice_div,
                          expression: "invoice_div",
                        },
                      ],
                    },
                    [
                      _c("div", { staticClass: "p-20 p-b-10" }, [
                        _c("p", [
                          _vm._v("Перемещение "),
                          _c("strong", [_vm._v(_vm._s(_vm.send_store_name))]),
                          _vm._v(" на\n                                "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.receive_store_name)),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-8" },
                          [
                            _c("VueCtkDateTimePicker", {
                              attrs: {
                                format: "DD.MM.YYYY HH:mm",
                                "minute-interval": "10",
                                buttonNowTranslation: "Сегодня",
                                label: "Дата и время доставки",
                              },
                              model: {
                                value: _vm.invoice_date,
                                callback: function ($$v) {
                                  _vm.invoice_date = $$v
                                },
                                expression: "invoice_date",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-4" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoice_status,
                                  expression: "invoice_status",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.invoice_status = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "1" } }, [
                                _vm._v("предварительная ведомость"),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "2" } }, [
                                _vm._v("в дороге"),
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "0" } }, [
                                _vm._v("фактическое перемещение"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("div", { staticClass: "form-group p-t-10" }, [
                            _c("label", [_vm._v("Комментарий")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoice_comment,
                                  expression: "invoice_comment",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { placeholder: "" },
                              domProps: { value: _vm.invoice_comment },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.invoice_comment = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "vue-ladda",
                            {
                              attrs: {
                                "button-class": "btn btn-info",
                                "data-style": "zoom-in",
                                loading: _vm.submit_form_loading,
                              },
                              on: { click: _vm.createInvoice },
                            },
                            [_vm._v("Создать\n                            ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }